<div
  [style.max-width]="maxWidth()"
  (click)="clickButton($event)"
  [class]="btnClass"
  [attr.aria-label]="ariaLabel()"
  class="button">
  <ng-content></ng-content>
  @if (icon()) {
    <span [class]="icon()" class="icon-button"></span>
  }
</div>
